<template>
  <b-sidebar
    :id="`sidebar_blog`"
    class="guide-body"
    right
    no-header-close
    z-index="10000"
    no-header
    backdrop
  >
    <!--    @hidden=""-->
    <div class="blog-feedback-input">
      <div
        class="d-flex justify-content-between align-items-center title-wrapper"
      >
        <h2 class="title">
          Feedback
        </h2>
        <span class="ico ico_close" @click="closeFeedbacks">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16" cy="16" r="16" fill="#E4E6EB" />
            <g clip-path="">
              <path
                d="M16.7855 16.0008L22.9482 9.83807C23.1652 9.6211 23.1652 9.26932 22.9482 9.05238C22.7312 8.83543 22.3794 8.83541 22.1625 9.05238L15.9998 15.2151L9.83709 9.05238C9.62012 8.83541 9.26834 8.83541 9.0514 9.05238C8.83446 9.26935 8.83443 9.62113 9.0514 9.83807L15.2141 16.0008L9.0514 22.1635C8.83443 22.3804 8.83443 22.7322 9.0514 22.9492C9.15987 23.0576 9.30207 23.1119 9.44426 23.1119C9.58646 23.1119 9.72862 23.0576 9.83712 22.9492L15.9998 16.7865L22.1625 22.9492C22.2709 23.0576 22.4131 23.1119 22.5553 23.1119C22.6975 23.1119 22.8397 23.0576 22.9482 22.9492C23.1652 22.7322 23.1652 22.3804 22.9482 22.1635L16.7855 16.0008Z"
                fill="#606770"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect
                  width="14.2222"
                  height="14.2222"
                  fill="white"
                  transform="translate(8.88867 8.88892)"
                />
              </clipPath>
            </defs>
          </svg>
        </span>
      </div>
      <div class="text-area-wrapper">
        <b-form-textarea
          id="input-feedback"
          class="textarea-custom-scrollbar"
          placeholder="Feedback"
          rows="3"
          no-resize
          v-model="feedback"
          @keydown.enter="postFeedback"
        ></b-form-textarea>
      </div>

      <div class="d-flex justify-content-end align-items-center ">
        <button class="btn btn-primary" @click="postFeedback">
          <span v-if="submitting">Submitting</span>
          <span v-else>Submit</span>
        </button>
      </div>
    </div>
    <div class="feedbacks" v-if="blog.feedback && blog.feedback.feedback">
      <div class="feedback" v-for="(feedback, i) in feedbacks" :key="i">
        <div class="user">
          <div class="user-img">
            <img :src="feedback.user.imgURL" alt="" />
          </div>
          <div class="details--user">
            <h4>{{ feedback.user.name }}</h4>
            <span class="date">
              <time-ago
                :refresh="1"
                :datetime="feedback._created_at.toDate()"
              ></time-ago>
              ago
            </span>
          </div>
        </div>
        <p class="feedback-text">
          {{ feedback.feedback }}
        </p>
        <div class="thanks">
          <span class="ico ico-thanks" @click="clapFeedback(feedback)">
            <template>
              <vLottiePlayer
                height="70px"
                width="70px"
                name="clap"
                :autoplay="false"
                loop
                @animControl="anim => (clap = anim)"
                :animationData="require('@/assets/Hand-Shaking.json')"
              />
            </template>
          </span>
          <span>{{ feedback.thankyous.length }} Thank You!</span>
        </div>
      </div>
    </div>
  </b-sidebar>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import TimeAgo from "vue2-timeago";
import VueLottiePlayer from "vue-lottie-player";
export default {
  name: "Feedback",
  props: ["blog"],
  data() {
    return {
      clap: null,
      feedback: "",
      submitting: false,
      timeoutInterval: null
    };
  },
  components: {
    TimeAgo,
    vLottiePlayer: VueLottiePlayer
  },
  computed: {
    ...mapGetters({
      user: "user/user"
    }),
    feedbacks() {
      return this.blog.feedback.feedback.slice().reverse();
    }
  },
  methods: {
    getDate(date) {
      return moment(date).format("DD MMMM");
    },
    getTime(date) {
      return moment(date).format("hh:mm A");
    },
    closeFeedbacks() {
      this.$root.$emit("bv::toggle::collapse", "sidebar_blog");
    },
    postFeedback() {
      if (this.feedback.trim() == "") return;
      if (!this.user) {
        this.$root.$emit("bv::toggle::collapse", "sidebar_blog");
        this.$bvModal.show("loginModal");
      } else {
        this.submitting = true;
        let data = {
          blogId: this.blog.id,
          feedback: {
            id: new Date().valueOf(),
            feedback: this.feedback.trim(),
            thankyous: [],
            user: {
              userId: this.user.uid,
              name: this.user.displayName,
              imgURL: this.user.photoURL
            }
          }
        };
        this.$store.dispatch("listings/postFeedback", data).then(() => {
          this.feedback = "";
          this.submitting = false;
          this.$emit("postedFeedback");
        });
      }
    },
    clapFeedback(feedback) {
      if (!this.user) {
        this.$root.$emit("bv::toggle::collapse", "sidebar_blog");
        this.$bvModal.show("loginModal");
      } else {
        let data = {
          userId: this.user.uid,
          blogId: this.blog.id,
          feedbackId: feedback.id
        };
        this.$store.dispatch("listings/clapFeedback", data).then(() => {
          this.$emit("postedFeedback");
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.blog-feedback-input {
  padding: 32px 24px 16px 32px;
  position: relative;
  &:after {
    content: "";
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    border-bottom: 1px solid #dddddd;
  }
  .title-wrapper {
    margin-bottom: 21px;
    .title {
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: bold;
      font-size: 20px;
      line-height: 27px;
      color: #474d52;
      margin: 0;
    }
    .ico_close {
      cursor: pointer;
      margin-right: 8px;
    }
  }
  .text-area-wrapper {
    background-color: #fff;
    padding: 8px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.04);
    border-radius: 8px;
    .textarea-custom-scrollbar {
      padding: 0;
      box-shadow: none;
      border: none;
      background-color: #fff;
      &::-webkit-scrollbar {
        width: 6px;
        background-color: #fff;
      }

      &::-webkit-scrollbar-track {
        background-color: #fff;
      }

      &::-webkit-scrollbar-thumb {
        width: 6px;
        height: 58px;
        background: #dddddd;
        border-radius: 8px;
      }
    }
  }
  .btn {
    margin-top: 16px;
    padding: 8px 20px;
    font-size: 16px;
    line-height: 22px;
    box-shadow: none;
    &:hover {
      transform: none;
    }
  }
}
.feedbacks {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 26px;
  color: #474d52;
  padding: 24px 32px;
  .user {
    margin-bottom: 16px;
    display: grid;
    grid-template-columns: 40px 1fr;
    grid-column-gap: 11px;
    align-items: center;
    .user-img {
      img {
        height: 40px;
        width: 40px;
        object-fit: cover;
        border-radius: 50%;
      }
    }
    .details--user {
      h4 {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 26px;
        color: #474d52;
        margin: 0;
      }
      .date,
      .v-time-ago__text {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        color: #8d99a0;
      }
    }
  }
  .feedback-text {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    color: #474d52;
  }
  .thanks {
    display: grid;
    grid-template-columns: 24px 1fr;
    grid-column-gap: 8px;
    align-items: center;
    .ico {
      cursor: pointer;
      &.ico-thanks {
        transform: translate(-25px, -10px);
      }
    }

    span {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #8d99a0;
    }
  }
}
</style>
<style>
.v-time-ago__text {
  font-family: inherit !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 12px !important;
  line-height: 16px !important;
  color: #8d99a0 !important;
}
</style>
